import React from 'react'
import { browserHistory, Route, Router } from 'react-router'
import Recherche from './Page/Recherche'

export default _ =>
    <Router history={browserHistory}>
        <Route path="/hotel/reservation" component={Recherche} />
    </Router>



// WEBPACK FOOTER //
// ./app/App/Module/Hotel/index.js